export { default } from "./TabScrollButton.mjs";
export { default as tabScrollButtonClasses } from "./tabScrollButtonClasses.mjs";
export * from "./tabScrollButtonClasses.mjs";